import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { ehAdmin } from '../shared/papeis';

export interface DecodedToken {
  username: string;
  sub: string;
  /** Papel principal — exibição e fallback (at-81). */
  userType: string;
  /** Todos os papéis; ausente em token emitido antes da at-81. */
  papeis?: string[];
  /** Tela inicial vinda do grupo de acesso de maior prioridade (at-81). */
  telaInicial?: string | null;
  isAdmin: boolean;
  isRefreshToken: boolean;
  codigoVoluntario: number | null;
  codigoRegional: number | null;
  iat: number;
  exp: number;
}

export default function useIsAdmin(): boolean {
  const token = useSelector((state: any) => state.auth.accessToken);

  if (!token) return false;

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    // Administrador é quem TEM o papel ADMIN, em qualquer posição (at-81). A flag isAdmin do
    // JWT segue legada e sem poder (ADR 0010).
    return ehAdmin(decoded);
  } catch {
    return false;
  }
}
